/** Minimales Routing ohne Bibliothek: "/" = Startseite, "/haus/<zustand>" = Haus. */
import { useSyncExternalStore } from "react";
import { isHouseKey, type HouseKey } from "@hausplaner/model";

export type Route = { page: "start" } | { page: "house"; key: HouseKey };

function parse(path: string): Route {
  const m = /^\/haus\/([a-z]+)\/?$/.exec(path);
  return m && isHouseKey(m[1]) ? { page: "house", key: m[1] } : { page: "start" };
}

const listeners = new Set<() => void>();
let current = parse(location.pathname);
addEventListener("popstate", () => { current = parse(location.pathname); listeners.forEach((l) => l()); });

export function navigate(path: string) {
  if (path === location.pathname) return;
  history.pushState(null, "", path);
  current = parse(path); listeners.forEach((l) => l());
}
export const houseUrl = (k: HouseKey) => `/haus/${k}`;

export function useRoute(): Route {
  return useSyncExternalStore((cb) => { listeners.add(cb); return () => listeners.delete(cb); }, () => current);
}
